<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: 'Sucursales',
          link: 'companies',
        },
        {
          text: $route.params.id,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else>
      <div
        class="breadcrumbs"
        style="font-size: 1em; margin: 15px; padding: 0 15px"
      >
        <div class="col-3" style="display: inline">
          <img
            :src="company.photo"
            style="clip-path: circle(27px at center); width: 60px; height: 60px"
            alt="Foto sucursal"
          />
          {{ company.name }}
          &nbsp;
          <router-link
            :to="`/companies/${company.id}`"
            title="Editar compañía"
            class="main-green"
          >
            <i class="fa fa-edit fa-2x"></i>
          </router-link>
        </div>
        <div style="display: inline">
          <!-- Tabs -->
          <ul class="nav justify-content-center" style="display: inline-flex">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#canastas"
                role="tab"
                aria-controls="canastas"
                aria-selected="true"
                >CANASTAS</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#prodcutos"
                role="tab"
                aria-controls="prodcutos"
                aria-selected="true"
                >PRODUCTOS</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#categorias"
                role="tab"
                aria-controls="categorias"
                aria-selected="true"
                >CATEGORIAS</a
              >
            </li>
            <li class="nav-item" v-if="$userIsAdmin()">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#sucursales"
                role="tab"
                aria-controls="sucursales"
                aria-selected="true"
                >PROVINCIAS</a
              >
            </li>
            <li class="nav-item" v-if="$userIsAdmin() && company.api_enabled">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#api"
                role="tab"
                aria-controls="api"
                aria-selected="true"
                >API</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content" id="myTabContent">
        <!-- CANASTAS TAB CONTENT -->
        <div
          class="tab-pane fade show active p-20"
          id="canastas"
          role="tabpanel"
          aria-labelledby="canastas-tab"
        >
          <Baskets :company="company.id" />
        </div>
        <!-- PRODUCTOS TAB CONTENT -->
        <div
          class="tab-pane fade p-20"
          id="prodcutos"
          role="tabpanel"
          aria-labelledby="prodcutos-tab"
        >
          <Products :company="company.id" />
        </div>
        <div
          class="tab-pane fade p-20"
          id="categorias"
          role="tabpanel"
          aria-labelledby="categorias-tab"
        >
          <Categories :company="company.id" />
        </div>

        <!-- SUCURSALES TAB CONTENT -->
        <div
          v-if="$userIsAdmin()"
          class="tab-pane fade p-20"
          id="sucursales"
          role="tabpanel"
          aria-labelledby="sucursales-tab"
        >
          <ProvinceBranchOffices
            :companyId="company.id"
            :branchOfficeId="company.id"
          />
        </div>

        <!-- API TAB CONTENT -->
        <div
          v-if="$userIsAdmin()"
          class="tab-pane fade p-20"
          id="api"
          role="tabpanel"
          aria-labelledby="api-tab"
        >
          <CompanyAPI :companyId="company.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Products from "../components/Products";
import Baskets from "../components/Baskets";
import ProvinceBranchOffices from "../components/ProvinceBranchOffices";
import ImageSelectBtn from "../components/ImageSelectBtn";
import Categories from "../components/Categories";
import Breadcrumbs from "../components/Breadcrumbs";
import Loader from "../components/Loader";
import CompanyAPI from "../components/CompanyAPI";
import { CompanyService } from "../../services/CompanyService";
import { UtilsService } from "../../services/UtilsService";

export default {
  name: "CompanyProfile",
  components: {
    Breadcrumbs,
    Loader,
    Products,
    Baskets,
    ProvinceBranchOffices,
    ImageSelectBtn,
    Categories,
    CompanyAPI,
  },
  data: function () {
    return {
      loading: false,
      driverOrders: [],
      provinces: [],
      driver: {},
      company: {
        id: "",
        name: "",
        photo: "",
      },
      companyService: new CompanyService(),
      utilsService: new UtilsService(),
    };
  },
  methods: {},
  beforeMount: async function () {
    this.loading = true;
    const res = await this.companyService.getCompanyData(this.$route.params.id);
    if (res.ok) {
      this.company = res.data;
    } else {
      this.$helpers.message("Error", res.message, "error");
    }
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/colors";
.pic {
  height: 175px;
  width: 175px;
  text-align: center;
  img {
    height: inherit;
    width: auto;
  }
}
th,
td {
  font-weight: 400;
}
.breadcrumbs {
  padding: 10px 15px;
  margin-bottom: 20px;
  background-color: #fff;
  -webkit-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.8);
  box-shadow: 0px 4px 11px -4px rgba(0, 0, 0, 0.8);
  font-size: 1.5em;
  .base {
    font-weight: 500;
    color: #000;
  }
  .child {
    font-weight: 400;
  }
}
.company-circle-pic {
  max-height: 30px;
  max-width: 40px;
  widows: auto;
  // clip-path: circle(20px at center);
}
.photo-container {
  height: 33vh;
}
.photo-container img {
  height: inherit;
}
.disabled-company {
  background-color: #ffa6a6;
}
thead th {
  font-weight: bold;
}
table td {
  font-size: 0.8rem !important;
}
.vscroll {
  max-height: 400px;
  overflow-y: auto;
}
* {
  font-weight: 500;
}
.nav-item a {
  font-weight: bold;
  color: #000;
}
.nav-item a.active {
  color: $main-green-color;
  border-bottom: solid 2px;
}
.p-20 {
  padding: 10px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 23px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #2196f3;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.history-table-container {
  overflow-y: auto;
  max-height: 450px;
  overflow-x: hidden;
}
.bold {
  font-weight: bold !important;
}
#detail-modal .modal-content {
  margin: 0 auto !important;
  max-width: 1100px !important;
  // width: 1000px !important;
}
.company-tag-name {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.order-modal-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.photo-preview {
  height: 110px;
  width: auto;
  object-fit: cover;
}
@media screen and(max-width:500px) {
  .order-modal-footer {
    justify-content: flex-start;
    flex-direction: column;
  }
}
</style>
